<template>
  <div class="relative z-10 hidden md:block">
    <div class="flex items-center ml-4 md:ml-6">
      <div class="relative ml-3">
        <div>
          <button
            @click="$emit('toggle')"
            class="flex items-center max-w-xs text-sm text-white rounded-full focus:outline-none focus:bg-gray-900"
          >
            <img class="h-8 rounded-full" :src="require('../../assets/logo.png')" />
          </button>
        </div>

        <transition
          enter-active-class="transition duration-100 ease-out"
          enter-class="scale-95 opacity-0"
          enter-to-class="scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-class="scale-100 opacity-100"
          leave-to-class="scale-95 opacity-0"
        >
          <div v-show="isOpen" class="absolute right-0 w-64 mt-2 origin-top-right transform rounded-md shadow-lg">
            <div class="py-1 font-semibold text-gray-700 bg-white rounded-md shadow-xs">
              <div class="px-4 pt-2">
                <span class="font-bold tracking-wide uppercase">{{ nombreCompleto }}</span>
              </div>

              <div class="px-4 pt-4 text-sm">
                <span class="font-bold">Nº afiliado</span>
                <span class="ml-2 font-normal">{{ contrato | nroAfiliado(integrante) }}</span>
              </div>

              <div class="px-4 pt-1 text-sm">
                <span class="font-bold">{{ documento.tipo }}</span>
                <span class="font-normal ml-14">{{ documento.numero }}</span>
              </div>

              <div class="mt-2 border-b border-gray-300"></div>

              <router-link class="block px-4 py-2 text-gray-700 hover:bg-gray-200" to="/">
                Mis credenciales
              </router-link>

              <a @click="logout" href="#" class="block px-4 py-2 text-gray-700 hover:bg-gray-200">
                Cerrar sesión
              </a>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import * as auth from '@/auth'
import credentialProps from '@/mixins/credentialProps'

const { emitLogout } = auth

export default {
  props: {
    isOpen: { type: Boolean, required: true },
    user: { type: Object, required: true },
  },

  mixins: [credentialProps],

  methods: {
    logout() {
      emitLogout()
    },
  },

  computed: {
    credencial() {
      return this.user.credencial
    },
  },
}
</script>
